import { X } from 'lucide-react';
import { useUIStore } from '@/stores/ui';
import { cn } from '@/lib/cn';

const VARIANT_STYLES = {
  info:    'bg-white border-[#E3E3F1] text-[#12122C]',
  success: 'bg-[#ECFDF5] border-[#A7F3D0] text-[#047857]',
  error:   'bg-[#FEF2F2] border-[#FECACA] text-[#B91C1C]',
  warning: 'bg-[#FFFBEB] border-[#FDE68A] text-[#B45309]',
};

const ACTION_STYLES = {
  info:    'text-[#0410BD] hover:underline',
  success: 'text-[#047857] hover:underline',
  error:   'text-[#B91C1C] hover:underline',
  warning: 'text-[#B45309] hover:underline',
};

export function ToastRegion() {
  const toasts = useUIStore((s) => s.toasts);
  const dismiss = useUIStore((s) => s.dismissToast);

  return (
    <div className="fixed top-4 right-4 z-[100] flex flex-col gap-2 w-80">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            'border rounded-lg shadow-[0_8px_20px_rgba(15,23,42,0.10)] p-3 text-sm flex gap-2 items-start',
            VARIANT_STYLES[t.variant],
          )}
          role="status"
        >
          <div className="flex-1 min-w-0">
            <div className="font-semibold">{t.title}</div>
            {t.body ? <div className="text-xs opacity-80 mt-0.5 break-words">{t.body}</div> : null}
            {t.action ? (
              <button
                type="button"
                onClick={async () => {
                  try {
                    await t.action!.onClick();
                  } finally {
                    dismiss(t.id);
                  }
                }}
                className={cn('mt-2 text-xs font-semibold', ACTION_STYLES[t.variant])}
              >
                {t.action.label}
              </button>
            ) : null}
          </div>
          <button
            onClick={() => dismiss(t.id)}
            className="text-current/60 hover:text-current"
            aria-label="Dismiss"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
